<template>
  <div class="zwx-ipc" v-show="false"></div>
</template>

<script>
export default {
  name: "ZwxIpc",
  props: {
    // 是否重复提示服务未启动
    ifRepeat: { type: Boolean, default: true },
  },
  data() {
    return {
      wss: "wss://127.0.0.1:13566",
      connection: null,
      ifConnection: false,
      ifNotice: true,
    };
  },
  created() {},
  watch: {},
  mounted() {},
  computed: {},
  methods: {
    // callback 0、失败 1、成功
    async connect(callback) {
      if (this.ifConnection) return callback !== undefined && callback(1);

      if (this.connection !== null) return;

      const wss = await this.$zwxJsStore.getJsStore("ms-ipc-wss");
      if (wss !== undefined && wss !== null && wss.trim() !== "")
        this.wss = wss;

      this.connection = new WebSocket(this.wss);

      // 服务器连接成功
      this.connection.onopen = () => {
        this.ifConnection = true;
        this.connection !== null && callback !== undefined && callback(1);
      };

      // 服务器连接出错
      this.connection.onerror = () => {
        this.ifConnection = false;
        this.connection !== null && callback !== undefined && callback(0);
        this.connection = null;
      };

      // 服务器关闭
      this.connection.onclose = () => {
        this.ifConnection = false;
        this.connection = null;
      };

      // 接收消息
      this.connection.onmessage = (event) => {
        if (!this.ifConnection) return;

        // this.$system.consoleLog("WebSocket接收到的消息", event.data);

        this.$emit("message", JSON.parse(event.data));
      };
    },
    // 发送消息
    send(message) {
      this.connect((result) => {
        if (result === 0) {
          this.$emit("connect", false);
          if (this.ifNotice)
            this.$system.message(
              "中卫信设备通信服务未运行，请检查！",
              "warning"
            );
          if (!this.ifRepeat) this.ifNotice = false;
          return;
        }

        this.$emit("connect", true);
        this.connection.send(JSON.stringify(message));
      });
    },
    // 检查中卫信设备通信服务运行状态
    check() {
      this.connect((result) => {
        if (result === 0) {
          this.$emit("connect", false);
          this.$system.message("中卫信设备通信服务未运行，请检查！", "warning");
          return;
        }

        this.$emit("connect", true);
      });
    },
  },
  beforeDestroy() {
    if (this.ifConnection) this.connection.close();
    this.ifConnection = false;
    this.connection = null;
  },
};
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
